import type { XdTheme } from '@xdface/tokens';

/**
 * Resolve a CSS custom property from the document root.
 * Canvas/SVG renderers (echarts, force-graph) cannot use var() directly,
 * so theme tokens are read at render time. Returns `fallback` when the
 * property is not set (e.g. jsdom in tests). React context can update before
 * its provider applies the root attribute; then use the requested palette
 * instead of caching a value from the previous appearance.
 */
export function resolveCssVar(name: string, fallback: string, theme?: XdTheme): string {
  if (typeof window === 'undefined' || typeof document === 'undefined') return fallback;
  if (theme && document.documentElement.getAttribute('data-xd-theme') !== theme) return fallback;
  const value = getComputedStyle(document.documentElement).getPropertyValue(name).trim();
  return value || fallback;
}
